import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await login(email, password); nav("/"); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-14 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)", backgroundSize: "48px 48px" }} />
        <div className="relative flex items-center gap-3"><div className="h-10 w-10 rounded-lg bg-blue-600 grid place-items-center"><Compass size={20} /></div><span className="font-extrabold text-lg">Sales Navigator</span></div>
        <div className="relative fade-up">
          <div className="label-xs !text-blue-400 mb-4">Borrow A Geek · Sales OS</div>
          <h1 className="text-5xl font-extrabold tracking-tight leading-[1.05]">Every lead.<br />Every touch.<br /><span className="text-blue-400">One heading.</span></h1>
          <p className="mt-6 text-slate-400 max-w-md">CRM, tracked campaigns, landing pages and AI research — built for a 4-step outreach rhythm.</p>
        </div>
        <div className="relative flex gap-2 text-[11px] font-mono text-slate-500">
          {["01 Cold Email", "02 Follow-up", "03 Follow-up 2", "04 Close"].map((s) => <span key={s} className="border border-slate-700 rounded px-2 py-1">{s}</span>)}
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-up" data-testid="login-form">
          <div>
            <h2 className="text-2xl font-extrabold tracking-tight">Sign in</h2>
            <p className="text-sm text-slate-500 mt-1">Use your Sales Navigator account.</p>
          </div>
          <div className="space-y-2"><label className="label-xs">Email</label>
            <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div className="space-y-2"><label className="label-xs">Password</label>
            <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
          <Button data-testid="login-submit-button" disabled={busy} className="w-full h-11 rounded-full">{busy ? "Signing in…" : <>Sign in <ArrowRight size={16} className="ml-1" /></>}</Button>
        </form>
      </div>
    </div>
  );
}
